angular.module("app").controller("LoginController", [
    '$scope',
    'userService',
    'userStorage',
    '$state',
    'settingsService',
    '$cookies',
    function ($scope, userService, userStorage, $state, settingsService, $cookies) {
        var init;

        (init = function () {
            $scope.userInfo = {
                username: "",
                password: ""
            };
            $('body').removeClass('toast-to-top');
        })();

        $scope.error = {};

        $scope.currentYear = (new Date()).getFullYear();
        $('body').addClass('toast-to-top');
        $scope.submitForm = function (login_form) {
            userService.login($scope.userInfo).then(
                function (userData) {
                    if (userData.status == "ok") {
                        if(userData.t) {
                            localStorage.setItem("t", userData.t);
                        }
                        $cookies.remove("preferedLanguage");
                        preLoadNecessaryData().then(
                            function (response) {
                                if (response.status == "ok") {
                                    document.addRelatedStates(response.userInfo.permissions, response.skin);

                                    userStorage.setUserData(angular.copy(response.userInfo));
                                    settingsService.setSettings(angular.copy(response));
                                    init();
                                    login_form.$setPristine();
                                    if(response.userInfo.permissions.indexOf('empty') !== -1){
                                        $state.go("main.empty", null, {reload: true});
                                    }else {
                                        $state.go("main.configs.general", null, {reload: true});

                                    }
                                }
                            }
                        );

                    } else {
                        $scope.error.errorCode = userData.message;
                    }
                },
                function (response) {
                    //TODO handle error
                }
            );
        }
    }
]);
